import BasePopupHandler, {
    MAIN_BUTTON_ANCHORS,
    PopupMainButtonLocations,
} from './BasePopupHandler';
import GameObject from '../../../GameObject/GameObject';
import UIItem, { ITextData } from '../../../Prototype/UI/UIItem';
import Game from '../../../Game';
import BaseUISystem from '../BaseUISystem';
import { PlatformActions } from '../../../State/Game/PlatformActions';
import { PopupID } from '../../../State/UI/PopupID';

export default class ConfirmSignOutMenuHandler extends BasePopupHandler {
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.CONFIRM_SIGN_OUT_MENU, uiSystem);
    }

    public createPopup(params?: any) {
        this.submitBtnParams.text.textLocalizationKey = Game.locale.getText(
            'Accept'
        );
        this.submitBtnParams.text.style = this.getSubmitStyle();
        this.submitBtnParams.button = { cacheKey: 'button_medium_red' };
        this.submitBtnParams.background.layout = {
            anchors: MAIN_BUTTON_ANCHORS[PopupMainButtonLocations.LEFT],
            pivot: [0.5, 1],
            offsets: [0, 100, 0, 100],
            scale: [1, 1],
        };
        this.cancelBtnParams.background.layout.offsets = [0, 45, 0, 45];

        this.submitBtnParams.onClick = () =>
            Game.store.dispatch(PlatformActions.signOutFirebase());
        this.cancelBtnParams.onClick = () =>
            Game.store.dispatch(PlatformActions.cancelFirebaseSignOut());

        super.createPopup({
            buttons: [this.submitBtnParams, this.cancelBtnParams],
            title: Game.locale.getText('Warning'),
        });

        this.createMainInfo();
    }

    private createMainInfo(): void {
        const text: GameObject<PIXI.Container> = UIItem.createText(
            this.textParams
        );
        this.background.addChild(text);
    }

    protected textParams: ITextData = {
        name: 'confirm_signOut_text',
        textLocalizationKey: 'ConfirmSignOut',
        layout: {
            anchors: [0.5, 0.45, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#8b3130',
            fontSize: '32px',
        },
        bounds: [650, 400],
        wordWrap: true,
        wordWrapWidth: 650,
    };

    private getSubmitStyle() {
        return {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '50px',
            stroke: '#8a2831',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        };
    }

    protected titleParams: ITextData = {
        name: 'popup_title',
        text: 'Title',
        style: {
            fontFamily: 'FrancoisOne',
            strokeThickness: 5,
            fill: 'white',
            fontSize: '45px',
            stroke: '#ab3143',
            lineJoin: 'miter',
            miterLimit: 2,
            align: 'center',
        },
        layout: {
            anchors: [0.5, 0.45, 0.5, 0.45],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        bounds: [460, 240],
    };
}
